import type { BuildingDetailSections } from "../../../types/buildings-sections/details";

export const buildingDetails: BuildingDetailSections = {
  additionalDetails: {
    title: "Täiendavad detailid",
    floors: "Korruseid",
    parkingSpaces: "Parkimiskohti",
    energyRating: "Energiamärgis",
    lastRenovationDate: "Viimane renoveerimine",
    lastRenovationDates: "Renoveerimise kuupäevad",
    electricityUse: "Elektritarbimine (kWh/aastas)",
    heatingUse: "Kütteenergia (kWh/aastas)",
    heatingSource: "Kütte allikas",
    selectHeatingSource: "Vali kütte allikas",
    heatingSources: {
      gas: "Gaas",
      electricity: "Elekter",
      district: "Kaugküte",
      oil: "Õliküte",
      geothermal: "Maaküte",
      solar: "Päikeseenergia",
      biomass: "Biomass",
      other: "Muu",
    },
  },
  form: {
    name: "Hoone nimetus",
    address: "Aadress",
    registryCode: "Registrikood",
    yearBuilt: "Ehitusaasta",
    netArea: "Netopindala",
    create: "Loo hoone",
    success: "Hoone loodud",
    successDescription: "Hoone on edukalt loodud.",
    error: "Hoone loomine ebaõnnestus. Palun proovige uuesti.",
    redirecting: "Hoone loodud, suunamine…",
  },
  buildingSections: {
    technicalData: "Tehnilised andmed",
    rooms: "Ruumid",
    technicalSystems: "Tehnilised süsteemid",
    fireSafety: "Tuleohutus",
    structuralMaterials: "Konstruktsioonimaterjalid",
    finishes: "Viimistlused",
  },
};
